import * as P from 'plow-js';
import { handleActions } from 'redux-actions';
// component modal
import { modalRoutine } from './routines';
//////////////////////////////////////////////////

const initialState = {
  opened: false,
};

const toggleModal = (state, { payload }) => P.$set('opened', payload, state);

export default handleActions(
  {
    [modalRoutine.TRIGGER]: toggleModal,
  },
  initialState,
);
